
import { get, post, postJson } from '../utils/http'

export const fetchSbtOrganization = () => (get('SBT_FETCH_ORGANIZATIONS', `/admin/lawreports/organizations`))

export const fetchSbt = (id) => (get('FETCH_SBT', `/admin/lawreports/${id}`))

export const editLawPlace = (index, attr, value) => ({ type: 'CHANGE_LAWPLACE', payload: { index, attr, value } })

export const editCategoryPath = (index, attr, value) => ({ type: 'SBT_CHANGE_CATEGORY_PATH', payload: { index, attr, value } })

export const editCategoryDatabase = (index, value) => ({ type: 'SBT_CHANGE_CATEGORY_DATABASE', payload: { index, value } })

export const newCategoryPath = () => ({type:'SBT_NEW_CATEGORY_PATH'})

export const edit = (attr, value) => ({ type: 'EDIT_SBT', payload: { attr, value } })

export const save = ({
  id,
  originalFileName,
  caseNumber,
  actualCaseNumber,
  sourceId,
  source,
  decisionDate,
  introductionDate,
  publicationDate,
  startPageTitle,
  publishOnStartPageTipsTitle,
  publishOnStartPageTipsDate,
  publishOnStartPageTipsForDBs,
  court,
  organizations,
  published,
  publishOnStartPage,
  publishOnStartPageTips,
  preamble,
  content,
  fullText,
  lawPlaces,
  categoryPaths,
  baseDbType,
  sbtPlus,
}, watchlistSend) => {
  
  var body = { id,
    originalFileName,
    caseNumber,
    actualCaseNumber,
    sourceId,
    source,
    decisionDate,
    introductionDate,
    publicationDate,
    startPageTitle,
    publishOnStartPageTipsTitle,
    publishOnStartPageTipsDate,
    publishOnStartPageTipsForDBs,
    court,
    organizations,
    published,
    publishOnStartPage,
    publishOnStartPageTips,
    preamble,
    content,
    fullText,
    lawPlaces,
    categoryPaths,
    baseDbType,
    watchlistSend,
    sbtPlus };

  return postJson('SAVE_SBT', '/admin/lawreports/update', body);
}

export const deleteLawReport = (id) => {
  let form = new FormData();
  form.append('id', id);

  return post('SBT_DELETE', `/admin/lawreports/delete`, form)
}

export const deleteLawPlace = (index) => ({ type: 'DELETE_LAWPLACE', payload: { index } })

export const deleteCategoryPath = (index) => ({ type: 'SBT_DELETE_CATEGORY_PATH', payload: { index } })

export const clearCategoryPath = () => ({ type: 'SBT_CLEAR_CATEGORY_PATH' })

export const setCategoryPaths = (categoryPaths) => ({ type: 'SBT_SET_CATEGORY_PATHS', payload: categoryPaths })

export const clearLawplaces = () => ({ type: 'SBT_CLEAR_LAWPLACES' })

export const setLawplaces = (lawplaces) => ({ type: 'SBT_SET_LAWPLACES', payload: lawplaces })

export const cloneCategoryPath = (index) => ({ type: 'SBT_CLONE_CATEGORY_PATH', payload: { index } })

export const showNewLawplaceDialog = () => ({ type: 'SHOW_NEWLAWPLACEDIALOG' })

export const hideNewLawplaceDialog = () => ({ type: 'HIDE_NEWLAWPLACEDIALOG' })

export const fetchLawdocuments = () => get('FETCH_SBT_LAWDOCUMENTS', `/admin/lawdocuments/register/0`, 'payload')

export const addLawPlace = (lp, count, chapter) => ({

  type: 'ADD_SBT_LAWPLACE', payload: {
    lawplace: { sblDocumentId: lp.id, sblDescription: lp.title, sfsNumber: lp.sfsNumber, chapter },
    count
  }
})

export const deleteAttachment = (id) => {
  let form = new FormData();
  form.append('id', id);

  return post('SBT_DELETE_ATTACHMENT', `/admin/lawreports/attachments/delete`, form)
};

export const updateAttachmentId = (id) => ({ type: 'SBT_UPDATE_ATTACHMENT_ID', payload: id })

export const toggleShowFullTextUpload = (show) => ({ type: 'SBT_TOGGLE_SHOW_FULLTEXT_UPLOAD', payload: show } )

export const changeOrg = (index, value) => ({ type: 'SBT_CHANGE_ORG', payload: { index, value } })

export const loadAutoCompleteCategories = (database, options, args) => {
  let optionsQuery = options.map((o) => `options=${o}`).join('&')  
  return get('SBT_FETCH_AUTOCOMPLETE_CATEGORIES', `/lawreports/categories?database=${database}&skipCache=true&rawNames=true&searchType=${1}&${optionsQuery}&includeHidden=true`, 'payload', args )
}

export const filterCategories = (filtered) => ({type: 'SBT_FILTER_AUTOCOMPLETE_CATEGORIES', payload:filtered})

export const editCategoryPathId = (index, attr, value, id) => ({
  type: 'SBT_CHANGE_CATEGORY_PATH_ID', payload: {index, attr, value, id}
})

export const onChangeTab = (activeKey) => ({ type: 'TEMPLATE_CHANGE_TAB', payload: activeKey })



// WEBPACK FOOTER //
// ./src/sbt/sbtActions.js